<template>
  <div class="partycore">
    <div class="header">
      <!-- <div class="title">核心功能</div> -->
      <img :src="party2" alt="">
      <div class="border"></div>
    </div>

    <div class="titlelist">
      <div
        class="titleitem"
        :class="titleId == item.id ? 'active' : ''"
        v-for="item in titleList"
        :key="item.id"
        @click="clickTitle(item.id)"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="box" v-if="item.id == titleId">
            <div class="list1">
              <div class="item1" v-for="it in item.list" :key="it.id">
                <div class="title">{{ it.title }}</div>
                <div class="text">{{ it.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import party2 from '../../../assets/party/party2.png'

export default {
  setup() {
    return reactive({
      party2:party2,
      titleId: 1,
      titleList: [
        {
          id: 1,
          title: "党建管理",
        },
        {
          id: 2,
          title: "数据管理",
        },
        {
          id: 3,
          title: "学习平台",
        },
        {
          id: 4,
          title: "宣传工作",
        },
        {
          id: 5,
          title: "活动平台",
        },
        {
          id: 6,
          title: "监督平台",
        },
      ],
      list: [
        {
          id: 1,
          list: [
            {
              id: 1,
              title: "党员管理",
              text: "党员归案、党员状态变更、党内培训记录、党内表彰/处分、组织关系转入、组织关系转出",
            },
            {
              id: 2,
              title: "党组织管理",
              text: "党组织信息、干部任免录入、历任干部信息",
            },
            {
              id: 3,
              title: "党费管理",
              text: "党费台账、党费缴纳、党费收缴记录",
            },
            {
              id: 4,
              title: "党员发展",
              text: "党员发展信息、列为积极份子、确定发展对象、接收预备党员、预备党员转正、培养考察记录",
            },
            {
              id: 5,
              title: "组织生活",
              text: "组织生活管理、组织生活开展、党员大会纪录、委员大会记录、党小组会记录、党课记录",
            },
            {
              id: 6,
              title: "党章党规",
              text: "党内法规具有强烈政治属性、鲜明价值导向、科学治理逻辑、统一规范功能，高度凝结党的理论创新和实践经验",
            },
            {
              id: 7,
              title: "党员考评",
              text: "考核/评议方案、考核/评议记录、考核方案审批、党员考核分发、评议方案审批、民主评议分发",
            },
            {
              id: 8,
              title: "党群生活",
              text: "党群活动申办、活动开展记录",
            },
          ],
        },
        {
          id: 2,
          list: [
            {
              id: 1,
              title: "党组织数据分析",
              text: "通过大数据、云计算、移动互联网等新兴技术对党组织数据进行分析",
            },
            {
              id: 2,
              title: "党员情况数据分析",
              text: "党员人数、预备党员人数、入党申请人数、积极分子人数、发展对象人数、今年入党人数",
            },
            {
              id: 3,
              title: "党费管理",
              text: "党费收缴金额、党费支出金额",
            },
            {
              id: 4,
              title: "投票数据分析",
              text: "支持多选、单选，可匿名提交，真正实现民主投票",
            },
            {
              id: 5,
              title: "党费情况数据分析",
              text: "组织生活管理、组织生活开展、党员大会纪录、委员大会记录、党小组会记录、党课记录",
            },
            {
              id: 6,
              title: "党员发展情况数据分析",
              text: "申请入党初步培养、入党积极分子培养、确定发展对象、接收预备党员",
            },
            {
              id: 7,
              title: "组织生活数据分析",
              text: "党内的各种活动都属于党的生活，组织生活是党员生活的一部分",
            },
            {
              id: 8,
              title: "党员民族数据分析",
              text: "各个民族人数统计",
            },
          ],
        },
        {
          id: 3,
          list: [
            {
              id: 1,
              title: "线上培训",
              text: "员工按时进行线上党课培训",
            },
            {
              id: 2,
              title: "学习资料",
              text: "学习资料库及时更新，一目了然",
            },
            {
              id: 3,
              title: "考试中心",
              text: "公司党员进行线上考试",
            },
            {
              id: 4,
              title: "学习笔记",
              text: "党员学习重在坚持，学习期间注重笔记记录",
            },
            {
              id: 5,
              title: "专题学习",
              text: "学院可通过线上学习资料进行专题性学习",
            },
            {
              id: 6,
              title: "题库管理",
              text: "不再是传统的学习模式，新型的题库根据学院学习动态提前更新",
            },
          ],
        },
        {
          id: 4,
          list: [
            {
              id: 1,
              title: "专题专栏",
              text: "通过线下硬件设备进行智慧党建宣传工作",
            },
            {
              id: 2,
              title: "民生平台",
              text: "关注社区居民生活，实现精准扶贫的全面普及",
            },
            {
              id: 3,
              title: "会议中心",
              text: "会议开展情况记录、跟踪、图文展示，党支部大会、支委大会等",
            },
            {
              id: 4,
              title: "移动端宣传",
              text: "通过移动端APP、小程序专题专业有针对性的宣传智慧党建",
            },
          ],
        },
        {
          id: 5,
          list: [
            {
              id: 1,
              title: "民主投票活动",
              text: "支持民主投票式选举",
            },
            {
              id: 2,
              title: "党组织活动",
              text: "党委组织活动、组织生活会议等",
            },
            {
              id: 3,
              title: "党员投票活动",
              text: "党费收缴金额、党费支出金额",
            },
            {
              id: 4,
              title: "志愿者活动",
              text: "支持志愿者申请、志愿活动申请、志愿者积极分子等活动进行重要划分",
            },
            {
              id: 5,
              title: "主题日活动",
              text: "党员主题日活动计划、党日活动计划等",
            },
            {
              id: 6,
              title: "积极分子精准扶贫活动",
              text: "支持党员、党积极分子进行精准扶贫活动",
            },
            {
              id: 7,
              title: "党员活动计划",
              text: "党员活动及时更新，后期活动及时计划",
            },
            {
              id: 8,
              title: "社区会议活动",
              text: "会议开展情况记录、跟踪、图文展示，党支部大会、支委大会等",
            },
          ],
        },
        {
          id: 6,
          list: [
            {
              id: 1,
              title: "组织干部任免",
              text: "支持对上报的组织干部进行案件检查及任免工作",
            },
            {
              id: 2,
              title: "组织关系转入/转出",
              text: "组织关系转入转出情况分析",
            },
            {
              id: 3,
              title: "党组织整顿",
              text: "支持对软弱涣散党组织进行整顿",
            },
            {
              id: 4,
              title: "党员状态变更",
              text: "支持对党员信息变更状态列表展示",
            },
            {
              id: 5,
              title: "党群活动",
              text: "党群活动计划、实施情况展示",
            },
            {
              id: 6,
              title: "邀请党组织谈话",
              text: "及时邀请党组织进行谈话",
            },
            {
              id: 7,
              title: "党费缴纳",
              text: "党员缴费情况以列表情况展示",
            },
            {
              id: 8,
              title: "组织生活开展",
              text: "组织生活开展情况展示分析",
            },
          ],
        },
      ],
    });
  },
  methods: {
    clickTitle(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.partycore {
  margin: 80px auto 0;
}
.header {
  text-align: center;
}
.header img {
  width: 129px;
  margin: 0 auto;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #a2231d;
  margin: 20px auto 0;
}

.titlelist {
  width: 1180px;
  display: flex;
  justify-content: space-between;
  margin: 40px auto 0;
}
.titlelist .titleitem {
  padding: 13px 27px;
  cursor: pointer;
}
.titlelist .active {
  background: #9f231d;
  border-radius: 93px 93px 93px 93px;
  color: #fff;
}
@media screen and (max-width: 1180px) {
  .body {
    min-width: 1180px;
  }
}
.body {
  margin-top: 40px;
  background: #eb4d44;
  box-shadow: inset 0px 10px 20px 0px rgba(31, 81, 210, 0.06);
}
.body .list .item .box {
  width: 1180px;
  margin: 0 auto;
  padding: 40px 0 0;
}
.body .list .item .box .list1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .list .item .box .list1 .item1 {
  width: 340px;
  margin-bottom: 40px;
}
.body .list .item .box .list1 .item1 .title {
    font-size: 16px;
    color: #fff;
    padding-bottom: 20px;
    border-bottom: 1px solid #FFFFFF;
}
.body .list .item .box .list1 .item1 .text {
    font-size: 12px;
    color: #fff;
    margin-top: 20px;
}
</style>
